import React from 'react';

class UIClear extends React.Component {

    render() {

      return (
          <div className="clear"/>
      );
  }
}
export default UIClear;
